import { IntlProvider as ReactIntlProvider } from "react-intl";
import en from "locale/compiled-locales/en.json";
import { PropsWithChildren } from "react";

const messagesMap = {
  en,
} as const;

export type Locale = Uppercase<keyof typeof messagesMap>;

type LocalesMap = Record<Locale, keyof typeof messagesMap>;

export const locales = Object.keys(messagesMap).reduce<LocalesMap>(
  (result, locale) => ({
    ...result,
    [locale.toUpperCase()]: locale,
  }),
  {} as LocalesMap
);

const isCorrectLocale = (locale: string): locale is keyof typeof messagesMap =>
  !!Object.keys(messagesMap).includes(locale);

const getLocale = (): keyof typeof messagesMap => {
  const [locale] = navigator.language.split(/[-_]/);

  return isCorrectLocale(locale) ? locale : locales.EN;
};

const IntlProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const locale = getLocale();
  const messages = messagesMap[locale];

  return (
    <ReactIntlProvider {...{ locale, messages }}>{children}</ReactIntlProvider>
  );
};

export default IntlProvider;
